<style scoped>
.tool-row {
	cursor: pointer;
	transition: background-color 0.15s ease;
}
.tool-row:hover {
	background-color: rgba(13, 110, 253, 0.05);
}
.tool-icon {
	font-size: 1.5rem;
	width: 40px;
	text-align: center;
	color: #0d6efd;
}
</style>

<template>
	<div class="container mt-4">
		<div class="d-flex justify-content-between align-items-center mb-4">
			<h2><i class="bi bi-gpu-card"></i> Vision</h2>
		</div>

		<div class="table-responsive">
			<table class="table table-hover align-middle">
				<thead class="table-light">
					<tr>
						<th style="width: 50px"></th>
						<th style="width: 160px">Tool</th>
						<th>Description</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="tool in tools"
						:key="tool.route"
						class="tool-row"
						@click="router.push(tool.route)"
					>
						<td>
							<div class="tool-icon">
								<i :class="tool.icon"></i>
							</div>
						</td>
						<td class="fw-semibold">{{ tool.name }}</td>
						<td class="text-muted small">{{ tool.description }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

const router = useRouter();

interface Tool {
	name: string;
	icon: string;
	description: string;
	route: string;
}

const tools: Tool[] = [
	{
		name: "Manifest",
		icon: "bi bi-journal-code",
		description:
			"Browse training manifests — reproducible snapshots of tile samples for model training.",
		route: "/_/sudo/vision/manifest",
	},
	{
		name: "Runs",
		icon: "bi bi-play-circle",
		description:
			"Manage training runs — create runs from manifests and track progress.",
		route: "/_/sudo/vision/run",
	},
	{
		name: "Inference",
		icon: "bi bi-cpu",
		description:
			"Create ad-hoc vision inference tasks on Planet imagery with map-based selection.",
		route: "/_/sudo/vision/inference",
	},
	{
		name: "Analysis",
		icon: "bi bi-search",
		description:
			"Review vision analysis results, inspect tasks, and commit pools to the database.",
		route: "/_/sudo/vision/analysis-review",
	},
	{
		name: "Analysis Task",
		icon: "bi bi-clipboard-check",
		description:
			"Look up a vision.analysis_task row by ID and inspect its inference details.",
		route: "/_/sudo/vision/analysis-task",
	},
	{
		name: "Analysis Pool",
		icon: "bi bi-droplet",
		description: "Look up a vision.analysis_pool row by ID.",
		route: "/_/sudo/vision/analysis-pool",
	},
	{
		name: "Analysis Task Pool",
		icon: "bi bi-diagram-3",
		description: "Look up a vision.analysis_task_pool row by ID.",
		route: "/_/sudo/vision/analysis-task-pool",
	},
	{
		name: "Deduplication",
		icon: "bi bi-intersect",
		description:
			"Try out pool deduplication algorithms on a vision.analysis_task's pools.",
		route: "/_/sudo/vision/deduplication",
	},
	{
		name: "Training Corpus",
		icon: "bi bi-database-check",
		description:
			"Review the human-labeled pool corpus — browse pools by planet item and inspect source imagery and condition masks.",
		route: "/_/sudo/vision/corpus",
	},
];
</script>
